/* eslint-disable */
import { Injectable } from '@angular/core';
// import { Headers, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators';

@Injectable()
export class RestService {

  constructor(http: HttpClient) {
    this.http = http;
  }

  get(url) {
    return new Promise(resolve => {
      //console.warn(`XHR GET ${url}`);
      this.http.get(url).subscribe(res => {
        //console.warn(`XHR Response ${url}`);
        //if (console.table) console.table(res);
        resolve(res);
      });
    });
  }


  post(url, payload) {
    // @TODO Setup csrf tokens
    // Just until we can turn csrfToken back on!!!!
    // return new Promise(resolve => {
    //   this.http.get('/api/csrfToken').map(res => res.json()).subscribe(token => {
    //     const data = Object.assign({ payload: payload }, token);
    //     this.http.post(url, data).map(res => res.json()).subscribe(res => {
    //       console.log(`GET res ::: ${url}`, res);
    //       resolve(res);
    //     });
    //   });
    // });
    return new Promise(resolve => {
      this.http.post(url, payload).subscribe(res => {
        resolve(res);
      });
    });
  }

  authnRequest(url, payload) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return new Promise(resolve => {
      //console.warn(`XHR POST authnRequest(); ${url}`);
      //if (console.table) console.table(payload);
      this.http.post(url, payload, { headers, method: 'POST' }).subscribe(res => {
        //console.warn(`XHR Response authnRequest(); ${url}`);
        //if (console.table) console.table(res);
        resolve(res);
      });
    });
  }

  // We can leave this here for now
  getSchemas() {
    const mainSchemaObj = {};
    let k = 0;
    //if (console.table) console.table(mainSchemaObj);
    return new Promise(resolve => {
      this.http.get('/ola/assets/schemas/Schemas.json').subscribe(res => {
        const schemaLength = res.length;
        for (let i = 0; i < schemaLength; i++) {
          this.http.get(`/ola/assets/schemas/${res[i]}.json`).subscribe(res => {
            k++;
            Object.assign(mainSchemaObj, res);
            if (k === schemaLength) { resolve(mainSchemaObj); }
          });
        }
      });
    });
  }
}
